function enhanceArticleLayout(shell) {
  const sample = shell.closest('[data-cotigo-editor-section]')?.querySelector('[data-cotigo-layout-sample]')?.dataset.cotigoLayoutSample;
  if (!sample || shell.dataset.cotigoLayoutReady) return;
  shell.dataset.cotigoLayoutReady = 'true';
  const body = shell.querySelector('[data-cotigo-editor-content] rte-formatter');
  if (!body) return;
  const quick = shell.querySelector('[data-cotigo-editor-block-type="quick_answer"]');
  const intro = body.firstElementChild;
  if (quick && intro?.tagName === 'P') {
    const links = intro.querySelectorAll('a[href]');
    if (links.length) {
      const note = document.createElement('div');note.className = 'cotigo-reading-intro-source';
      links.forEach(link => note.append(link.cloneNode(true)));quick.append(note);
    }
    intro.remove();
  }
  if (sample === 'shopping') {
    body.querySelectorAll('h3[data-sku]').forEach(heading => {
      const figure = heading.nextElementSibling;
      if (figure?.tagName !== 'FIGURE') return;
      const panel = document.createElement('section');panel.className = 'cotigo-reading-product';
      heading.before(panel);const copy = document.createElement('div');
      panel.append(figure,copy);copy.append(heading);
      let sibling = panel.nextElementSibling;
      while (sibling && !['H2','H3'].includes(sibling.tagName)) {
        if (sibling.querySelector('a[href*="/collections/"]')) break;
        const next = sibling.nextElementSibling;copy.append(sibling);sibling = next;
      }
    });
  }
  if (sample === 'education') body.querySelectorAll('table').forEach(table => {
    const mobile = document.createElement('div');mobile.className = 'cotigo-reading-mobile-comparison';
    table.querySelectorAll('tbody tr').forEach(row => {
      const item = document.createElement('section');
      row.querySelectorAll('td').forEach((cell,i) => {
        const part = document.createElement(i === 0 ? 'h3' : 'p');
        part.append(...Array.from(cell.childNodes).map(n => n.cloneNode(true)));item.append(part);
      });mobile.append(item);
    });
    if (mobile.children.length) {
      const wrap = table.closest('.table-wrap') || table;wrap.dataset.cotigoResponsiveTable = 'true';wrap.after(mobile);
    }
  });
}

const readingInstances = new WeakMap();

class CotigoArticleReading {
  constructor(shell) {
    this.shell = shell;
    this.toc = shell.querySelector('[data-cotigo-reading-toc]');
    this.desktopSlot = shell.querySelector('[data-cotigo-reading-desktop-slot]');
    this.mobileSlot = shell.querySelector('[data-cotigo-reading-mobile-slot]');
    this.author = shell.querySelector('[data-cotigo-reading-author]');
    this.mobileAuthorSlot = shell.querySelector('[data-cotigo-reading-mobile-author-slot]');
    this.media = window.matchMedia('(min-width: 1024px)');
    this.handleLayout = this.handleLayout.bind(this);
    this.handleClick = this.handleClick.bind(this);
    if (!this.toc || !this.desktopSlot || !this.mobileSlot) return;
    this.media.addEventListener('change', this.handleLayout);
    this.toc.addEventListener('click', this.handleClick);
    this.handleLayout();
  }

  handleLayout() {
    const desktop = this.media.matches;
    (desktop ? this.desktopSlot : this.mobileSlot).append(this.toc);
    if (this.author && this.mobileAuthorSlot) (desktop ? this.desktopSlot : this.mobileAuthorSlot).append(this.author);
    this.toc.open = desktop;
  }

  handleClick(event) {
    const link = event.target instanceof Element ? event.target.closest('a[href^="#"]') : null;
    if (!link) return;
    const target = document.getElementById(decodeURIComponent(link.hash.slice(1)));
    if (!target) return;
    event.preventDefault();
    if (!this.media.matches) this.toc.open = false;
    window.requestAnimationFrame(() => window.requestAnimationFrame(() => {
      target.scrollIntoView({ block: 'start', behavior: 'instant' });
      if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
      target.focus({ preventScroll: true });
      if (window.location.hash !== link.hash) window.history.pushState(null, '', link.hash);
    }));
  }

  destroy() {
    this.media.removeEventListener('change', this.handleLayout);
    this.toc?.removeEventListener('click', this.handleClick);
  }
}

function initReading(root = document) {
  root.querySelectorAll('.cotigo-article-reading-comment-form').forEach((details) => {
    if (details.querySelector('.blog-post-comments__form-message')) details.open = true;
  });
  root.querySelectorAll('[data-cotigo-reading-shell]').forEach((shell) => {
    enhanceArticleLayout(shell);
    if (!readingInstances.has(shell)) readingInstances.set(shell, new CotigoArticleReading(shell));
  });
}

document.addEventListener('DOMContentLoaded', () => initReading());
document.addEventListener('shopify:section:load', (event) => initReading(event.target));
document.addEventListener('shopify:section:unload', (event) => {
  event.target.querySelectorAll('[data-cotigo-reading-shell]').forEach((shell) => {
    readingInstances.get(shell)?.destroy();
    readingInstances.delete(shell);
  });
});
